<template>
  <div class="bc-voucher">
    <div class="bc-voucher__inner">
      <a class="bc-voucher__back" href="javascript:;" @click.prevent="goBack">
        ← {{ $T('观众中心返回') }}
      </a>
      <h1 class="bc-voucher__title">{{ $T('观众中心上传付款凭证') }}</h1>
      <p class="bc-voucher__desc">{{ $T('观众中心上传付款凭证说明') }}</p>

      <section class="bc-voucher__card" v-if="account.beneficiary_account">
        <h2>{{ $T('观众中心收款账号') }}</h2>
        <p class="bc-voucher__line">
          <span>Account</span>
          {{ account.beneficiary_account }}
        </p>
        <p class="bc-voucher__line">
          <span>Beneficiary</span>
          {{ account.beneficiary_name }}
        </p>
        <p class="bc-voucher__amount" v-if="payPrice">
          {{ $T('观众中心应付') }}：<strong>{{ money(payPrice) }}</strong>
        </p>
      </section>

      <section class="bc-voucher__card">
        <div class="bc-voucher__field">
          <label>{{ $T('观众中心汇款时间') }}</label>
          <input v-model="form.pay_off_date" type="text" :placeholder="$T('观众中心汇款时间占位')" />
        </div>
        <div class="bc-voucher__field">
          <label>{{ $T('观众中心汇款单号') }}</label>
          <input v-model="form.pay_off_id" type="text" :placeholder="$T('观众中心汇款单号占位')" />
        </div>
        <div class="bc-voucher__field">
          <label>{{ $T('观众中心付款截图') }} <em>*</em></label>
          <PicUploader :fileList="form.order_pics" :limit="3" :multiple="true" />
          <p class="bc-voucher__tip">{{ $T('观众中心付款截图提示') }}</p>
        </div>
        <button
          type="button"
          class="bc-voucher__submit"
          :disabled="saving"
          @click="submit"
        >
          {{ $T('观众中心提交凭证') }}
        </button>
      </section>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import PicUploader from '@/components/picker/PicUploader.vue';
import { spectatorMoney } from '@/utils/spectatorMoney';

export default {
  name: 'SpectatorOfflineVoucher',
  components: { PicUploader },
  data() {
    return {
      orderIds: [],
      payPrice: '',
      account: {},
      saving: false,
      form: {
        pay_off_date: '',
        pay_off_id: '',
        order_pics: [],
      },
    };
  },
  mounted() {
    document.title = this.$T('观众中心上传付款凭证');
    const q = this.$route.query || {};
    const rawIds = q.ids || '';
    this.orderIds = String(rawIds)
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
    this.payPrice = q.price || '';
    if (!this.orderIds.length) {
      Toast(this.$T('观众中心订单无效'));
      this.$router.replace({ path: '/spectator' });
      return;
    }
    this.fetchAccount();
    this.fetchDetail();
  },
  methods: {
    money: spectatorMoney,
    goBack() {
      this.$router.back();
    },
    fetchAccount() {
      const that = this;
      that.$api.get(
        '/api/order/offlinePayInfo',
        {},
        (res) => {
          that.account = res.data || {};
        }
      );
    },
    fetchDetail() {
      const that = this;
      that.$api.get(
        '/api/order/orderOfflineDetail',
        { id: that.orderIds[0] },
        (res) => {
          const data = res.data || {};
          if (data.pay_off_date) {
            that.form.pay_off_date = data.pay_off_date;
          }
          if (data.pay_off_id) {
            that.form.pay_off_id = data.pay_off_id;
          }
          if (data.order_pics && data.order_pics.length) {
            that.form.order_pics = data.order_pics;
          }
          if (data.pay_price && !that.payPrice) {
            that.payPrice = data.pay_price;
          }
          if (data.account) {
            that.account = data.account;
          }
        }
      );
    },
    submit() {
      const that = this;
      if (!that.form.order_pics || !that.form.order_pics.length) {
        Toast(that.$T('请上传支付凭证'));
        return;
      }
      that.saving = true;
      that.$api.post(
        '/api/order/orderOfflinePaySave',
        {
          id: that.orderIds.join(','),
          code: that.form.pay_off_id || '',
          time: that.form.pay_off_date || '',
          // 嵌套数组经 qs 易丢字段，整段 JSON 传给后端
          pics: JSON.stringify(that.form.order_pics),
        },
        () => {
          that.saving = false;
          Toast.success(that.$T('观众中心凭证已提交'));
          that.$router.replace({ path: '/spectator-orders' });
        },
        (res) => {
          that.saving = false;
          Toast((res && res.msg) || that.$T('观众中心凭证提交失败'));
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.bc-voucher {
  background: #f3f4f6;
  min-height: 50vh;
  padding: 32px 24px 80px;
}
.bc-voucher__inner {
  max-width: 640px;
  margin: 0 auto;
}
.bc-voucher__back {
  display: inline-block;
  margin-bottom: 12px;
  color: #5b6478;
  font-size: 14px;
  text-decoration: none;
}
.bc-voucher__title {
  margin: 0 0 8px;
  font-size: 24px;
  font-weight: 700;
  color: #1e2842;
}
.bc-voucher__desc {
  margin: 0 0 24px;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
}
.bc-voucher__card {
  background: #fff;
  border-radius: 12px;
  padding: 22px;
  margin-bottom: 16px;
  box-shadow: 0 6px 20px rgba(30, 40, 66, 0.06);
}
.bc-voucher__card h2 {
  margin: 0 0 12px;
  font-size: 15px;
  color: #1e2842;
}
.bc-voucher__line {
  margin: 0 0 8px;
  font-size: 13px;
  color: #1e2842;
  line-height: 1.4;
}
.bc-voucher__line span {
  display: block;
  font-size: 11px;
  color: #9ca3af;
  margin-bottom: 2px;
}
.bc-voucher__amount {
  margin: 12px 0 0;
  font-size: 14px;
  color: #374151;
}
.bc-voucher__amount strong {
  color: #c2410c;
  font-size: 18px;
}
.bc-voucher__field {
  margin-bottom: 18px;
}
.bc-voucher__field label {
  display: block;
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 8px;
}
.bc-voucher__field label em {
  color: #c2410c;
  font-style: normal;
}
.bc-voucher__field input {
  width: 100%;
  height: 40px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 0 12px;
  font-size: 14px;
  box-sizing: border-box;
}
.bc-voucher__tip {
  margin: 8px 0 0;
  font-size: 12px;
  color: #9ca3af;
}
.bc-voucher__submit {
  width: 100%;
  height: 46px;
  border: 0;
  border-radius: 8px;
  background: #c2410c;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 8px;
}
.bc-voucher__submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// SpectatorOfflineVoucher.vue?4ee9cdf6